var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Breadcrumbs } from 'components/Shared';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import useMeasure from 'react-use-measure';
import { breadcrumbUtils } from 'utils';
import { useActiveContext } from '../Context/ActiveContext';
import MobileSlideController from '../SlideController/MobileSlideController';
import { ProductJourneyPages } from '../pages';
import { BreadCrumbContainer, Container, MapBoundary, NextStepButton, StyledArrow, } from './styles';
const MobileProductJourney = (_a) => {
    var { MapComponent, showProductJourneyCards } = _a, mapProps = __rest(_a, ["MapComponent", "showProductJourneyCards"]);
    const { steps, activeStepIndex: activeIndex, handleStepChange, } = useActiveContext();
    const { t } = useTranslation();
    const scrollRef = useRef();
    const [measureRef, { width }] = useMeasure();
    if (!steps)
        return React.createElement(Container, null);
    const scrollToTop = () => {
        if (!(scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current))
            return;
        scrollRef.current.scrollIntoView();
    };
    return (React.createElement(Container, { ref: scrollRef, isMobile: true },
        React.createElement(MapBoundary, { ref: measureRef, isMobile: true },
            React.createElement(BreadCrumbContainer, null,
                React.createElement(Breadcrumbs, { config: [
                        breadcrumbUtils.getBreadcrumb(ProductJourneyPages.PRODUCT_JOURNEY, t),
                    ], mobile: true })),
            React.createElement(MapComponent, Object.assign({}, mapProps, { width: width, isSummaryMap: !showProductJourneyCards }))),
        React.createElement(React.Fragment, null,
            activeIndex === 0 && steps.length > 1 && showProductJourneyCards && (React.createElement(NextStepButton, { onClick: () => handleStepChange(activeIndex + 1) },
                t('next-step'),
                React.createElement(StyledArrow, { size: 20 }))),
            React.createElement(MobileSlideController, { scrollToTop: scrollToTop, showProductJourneyCards: showProductJourneyCards }))));
};
export default MobileProductJourney;
